import i18n from 'utils/i18n';

export const MODULE_NAME = 'rfp';

export const ADD_SUPPLIER_TXT = i18n.t('Assign suppliers');
export const NO_SUPPLIER_MANAGE_PERM_TXT = i18n.t(
  "You don't have the permission manage suppliers",
);
